import { ServerResponse } from 'http';

const cachePage = (res?: ServerResponse, time = 1000 * 60 * 10) => {
  res?.setHeader('anm-cache-control', time);
};

export default cachePage;
